import { Row, Col } from "react-bootstrap";
import Pagination from "./Pagination";

const GridList = ({
  items,
  perRow,
  paginationDisabled,
  itemsCount,
  perPage,
  ...props
}) => {
  if (items.length === 0)
    return (
      <Row className="justify-content-center">
        <Col md={6} xs={12} className="px-0 mx-0">
          <img
            className="not-found w-100"
            src={"/images/Reading glasses-pana.svg"}
            alt="Not Found"
          />
        </Col>
      </Row>
    );
  if (perRow < 4)
    return (
      <Row className="g-4">
        {items.map((item, i) => {
          return (
            <Col key={i} xl={4} lg={6} md={6} sm={6} xs={12}>
              <props.as item={item}></props.as>
            </Col>
          );
        })}
        {!paginationDisabled && (
          <Col xs={12} className="mt-4">
            <Pagination count={itemsCount} perPage={perPage} />
          </Col>
        )}
      </Row>
    );
  return (
    <>
      <Row className="g-4">
        {items.map((item, i) => (
          <Col key={i} xl={3} lg={4} md={6} sm={6} xs={12}>
            <props.as item={item}></props.as>
          </Col>
        ))}
        {!paginationDisabled && (
          <Col xs={12} className="mt-4">
            <Pagination count={itemsCount} perPage={perPage} />
          </Col>
        )}
      </Row>
    </>
  );
};

export default GridList;
